import React, { Component } from "react";
import { Tabs } from "antd";
import ArticleBuilder from "./ArticleBuilder";
import KontentMachine from "./KontentMachine";
import ArticleForge from "./ArticleForge";
import UltraSpinnableArticle from "./UltraSpinnableArticle";
import OpenAI from "./OpenAI";
import co from "co";

const TabPane = Tabs.TabPane;

class ContentTab extends Component {
	// validateForm = () => {
	// 	return co(function*() {
	// 		const response = yield this.articleBuilder.validateForm();
	// 		return response;
	// 	}.bind(this));
	// };
	render() {
		return (
			<Tabs tabPosition="left">
				<TabPane tab="OpenAI" key="openAI">
					<OpenAI />
				</TabPane>
				<TabPane tab="Article Forge" key="articleForge">
					<ArticleForge />
				</TabPane>
				<TabPane tab="Article Builder" key="articleBuilder">
					<ArticleBuilder
						ref={articleBuilder => {
							if (articleBuilder != null) {
								this.articleBuilder = articleBuilder.wrappedInstance;
							} else {
								this.articleBuilder = null;
							}
						}}
					/>
				</TabPane>
				<TabPane tab="Kontent Machine" key="kontentMachine">
					<KontentMachine />
				</TabPane>
				<TabPane tab="Ultra Spinnable Article" key="usa">
					<UltraSpinnableArticle />
				</TabPane>
			</Tabs>
		);
	}
}

export default ContentTab;
